import React, { MouseEventHandler, useEffect, useState } from 'react';
import axios, { AxiosResponse } from 'axios';
import 'babel-polyfill';
import { formatLongDateTime } from './util';
import { Appointment } from './interfaces';
import FormWrapper from './formwrapper';
import { labels } from './labels';

interface IProps {
    name: string;
    scheduleDate: Date
}

const BookingComplete = (props: IProps) => {
    const urlParams = new URLSearchParams(window.location.search);
    const bookingId = urlParams.get('bookingId');    

    const [appt, setAppt] = useState<Appointment>();

    useEffect(() => {
        axios.get(`api/appointments?bookingId=${bookingId}`)
            .then((result) => {
                setAppt(result.data);
            })
    }, [])

    return (
        appt ?
            (appt.npi ?
                <FormWrapper currentStep={5}>
                    {/*<FormProgress currentStep={5} />*/}
                    <div className="mt-2">
                        <p className="lead">{labels.bookingcomplete.title}</p>
                    </div>
                    <div className="row mb-4">                        
                        {appt.photo &&
                            <div className="col-auto">
                            <img src={(window as any).PHOTO_URL + appt.photo} alt={appt.firstName + " " + appt.lastName} style={{ width: "150px" }} />
                            </div>
                        }
                        <div className="col">
                            <div>
                                <p><strong>Provider</strong>: {appt.firstName} {appt.lastName}{appt.academicTitle && (", " + appt.academicTitle)}</p>
                                <p><strong>Time</strong>: {formatLongDateTime(new Date(appt.startTime))}</p>
                                <p><strong>Location</strong>: {appt.virtualist ? <b>Virtual Primary Care</b> : <>
                                    <br />
                                    {appt.clinic}&nbsp;<span className="badge rounded-pill bg-secondary text-light">{appt.apptType == "2" ? "Virtual Visit" : "In Person"}</span><br />
                                    {appt.address1}<br />
                                    {appt.city}, {appt.state} {appt.zipCode}<br />
                                    {appt.phone}<br /></>}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="">
                        <h2 className="mb-3">{labels.bookingcomplete.heading}</h2>
                        {appt.virtualist ?
                            labels.virtualistbookingcomplete.message(appt.phone) :
                            labels.bookingcomplete.message(appt.phone)}
                    </div>
                </FormWrapper> :
                <FormWrapper currentStep={0}>
                    No appointment found. Please contact your provider if you booked an appointment but did not receive a confirmation.
                </FormWrapper>
            ) : <div></div>
    );
}

export default BookingComplete;